import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
import { useAppContext } from '../context/AppContext';
export const GATE_DEFINITIONS = {
  breezeAssistant: gate('Marketplace::Storefront::BreezeAssistant'),
  newDashboard: gate('Marketplace::Storefront::NewDashboard'),
  tabularSearch: gate('Marketplace::Storefront::TabularSearch'),
  techPartnerTier: gate('Marketplace::Apps::TechPartnerTier'),
  workflowTemplatesPhase2: gate('Marketplace::WorkflowTemplates::Phase2')
};
function getGates() {
  try {
    return userInfoSync().gates;
  } catch (_unused) {
    return [];
  }
}
export function useGates() {
  const gates = getGates();
  const appContext = useAppContext();
  const isPublic = appContext === 'public';
  return useMemo(() => Object.assign({}, Object.fromEntries(Object.entries(GATE_DEFINITIONS).map(([k, g]) => [k, gates.includes(g)])), {
    newDashboard: isPublic || gates.includes(GATE_DEFINITIONS.newDashboard),
    workflowTemplatesPhase2: isPublic || gates.includes(GATE_DEFINITIONS.workflowTemplatesPhase2)
  }), [gates, isPublic]);
}